import '@backstage/cli/asset-types';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';

createRoot(document.getElementById('root')!).render(App);
